export default "__VITE_ASSET__LkkuIacz__"